import { AuthVM } from "../ViewModels/Auth/AuthVM";
import { SideBarVM } from "../ViewModels/SideBarVM";

export class Globals {
    public static  auth:AuthVM = new AuthVM()
    public static sideBar:SideBarVM = new SideBarVM()
}
